export default __webpack_public_path__ + "static/media/meet-the-replacements.9a07be19.jpg";